import React from "react";
import { twMerge } from "tailwind-merge";

// Common form styles used across components
export const formStyles = {
  label:
    "font-alexandria font-normal block dark:text-[#FFFFFF] text-[#1a1a1a] text-sm md:text-[16px] lg:text-[18px] laptop:text-[20px] 3xl:text-[22px] mb-2",
  dropDownlabel:
    "text-[#FFFFFF] font-public-sans font-medium text-[14px] text-left mb-[10px]",
  helpText:
    "text-[#686868]  text-[10px] sm:text-[.6875rem] 3xl:text-[.75rem] 4xl:text-[.8125rem] font-public-sans font-normal mb-2 text-left mt-1",
  errorText:
    "text-[#FF0000] text-[10px] sm:text-[12px] 3xl:text-[13px] 4xl:text-[14px] font-inter font-normal leading-[12px] block",
  errorContainer: "h-[2px] mt-1",
  requiredStar: "text-[#FF1CF7]",
  input:
    "w-full h-[42px] sm:h-[46px] md:h-[50px] 3xl:h-[54px] 4xl:h-[58px] rounded-[5px] px-[14px] py-3 text-foreground font-manrope text-sm 3xl:text-base 4xl:text-[17px] border transition-colors " +
    "bg-[#F7F5FA] placeholder-[#12121257]/90 border-[#12121257] " +
    "dark:bg-[#181A20] dark:placeholder-white/60 dark:border-white/20 " +
    "focus:outline-none focus:border-[#FF1CF7]",
  dropDown:
    "w-full  flex items-center justify-between px-4 py-3 bg-[#45444433] text-[#808080] font-normal font-public-sans text-sm rounded-md placeholder-[#808080]",
  dropDownOptions:
    "w-full flex items-center justify-between px-4 py-3 bg-[#262530] text-[#686868] font-normal font-public-sans text-sm  placeholder-[#686868] placeholder-opacity-80 my-[1px]",
  dropdownButton:
    "w-full h-[42px] sm:h-[46px] md:h-[50px] 3xl:h-[54px] 4xl:h-[58px] rounded-[5px] px-[14px] py-3 flex items-center justify-between text-left text-foreground/60 font-manrope text-sm border transition-colors " +
    "bg-[#F7F5FA] border-[#12121257] " +
    "dark:bg-[#181A20] dark:border-white/20 " +
    "focus:outline-none focus:border-[#FF1CF7]",

  dropdownMenu:
    "absolute top-full left-0 right-0 z-10 -mt-1 rounded-[5px] overflow-hidden border " +
    "bg-[#F7F5FA] border-[#12121257] " +
    "dark:bg-[#181A20] dark:border-white/20",

  dropdownOption:
    "w-full px-[14px] py-3 text-left font-manrope text-sm 3xl:text-base 4xl:text-[17px] text-foreground/80 hover:bg-foreground/10 transition-colors",
  textarea:
    "w-full h-[160px] 3xl:h-[180px] 4xl:h-[200px] rounded-[5px] px-[14px] py-3 text-foreground font-manrope text-sm 3xl:text-base 4xl:text-[17px] border transition-colors resize-none " +
    "bg-[#F7F5FA] placeholder-[#12121257]/90 border-[#12121257] " +
    "dark:bg-[#181A20] dark:placeholder-white/60 dark:border-white/20 " +
    "focus:outline-none focus:border-[#FF1CF7]",
};

/**
 * FormLabel - Reusable label component with consistent styling
 */
export const FormLabel = ({
  htmlFor,
  label,
  isRequired,
  className,
  helpText,
}) => {
  if (!label) return null;

  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(
        formStyles.label,
        helpText ? "mb-0" : "mb-[.625rem]",
        className
      )}
    >
      {label} {isRequired && <span className={formStyles.requiredStar}>*</span>}
    </label>
  );
};

/**
 * FormHelperText - Reusable helper text component with consistent styling
 */
export const FormHelperText = ({
  helpText,
  error,
  className,
  errorClassName,
}) => {
  return (
    <div className={twMerge(formStyles.errorContainer, className)}>
      {helpText && !error && (
        <span className={formStyles.helpText}>{helpText}</span>
      )}
      {error && (
        <span className={twMerge(formStyles.errorText, errorClassName)}>
          {error}
        </span>
      )}
    </div>
  );
};
